import React from 'react';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import { ReactComponent as LockIcon } from 'style/_assets/icons/lock-white.svg';
import './StandardHomeEquityOffer.scss';
import { useConfig } from 'hook/config.hook';

const StandardHomeEquityOffer = ({ offerMetadata, ...props }) => {
  let offer = offerMetadata?.bestProduct?.lender;
  const { config } = useConfig();
  return (
    <div className="homeEquityContainer format100 grayShadow border-rad8px margB24">
      <FlexContainer className="m-flex-column m-items-align-center m-padLR16 m-padTB48 pad24">
        <div className="homeEquityOfferImageContainer">
          <img
            data-testid={`${props.datatestid}-hl-offer-image`}
            className="homeEquityOfferImage"
            src={offer.logoUrl}
            alt="Home Equity Offer"
            onClick={props.clickApplyImageHandler}
          />
        </div>
        {props.seenPixel}
        <FlexContainer className="flex-column justify-between margL48 m-margl0 m-margT24">
          {/* 
         Will be added when slapi returns the right value      
          <div
            className="Subtitle-1 t-text-center pointer"
            dangerouslySetInnerHTML={{
              __html: offer.name,
            }}
            onClick={props.clickApplyLoanNameHandler}
          /> */}
          <div
            className="Body-2 t-text-12 m-margB24 bulletpoint-style"
            dangerouslySetInnerHTML={{
              __html: offer.bulletedContent,
            }}
          />
        </FlexContainer>
        <FlexContainer className="flex-column m-margT0 m-format100 m-items-align-center">
          <Button
            className="applyNowButton padR16 border-rad100px"
            mrphType="primary"
            onClick={props.clickApplyHandler}
            datatestid={`${props.datatestid}-ApplyNowButton`}
          >
            <FlexContainer className="justify-center align-items-center">
              <LockIcon
                className="lockIcon"
                style={{
                  position: 'relative',
                }}
              />
              Apply for Offer
            </FlexContainer>
          </Button>
          <FlexContainer className="justify-end mobile-justify-center padT4">
            <div className="padB8" />
            <div className="format100 text-center">
              <Label
                type="caption"
                color="fontGray300"
                data-testid={`${props.datatestid}-applyNowText`}
                className="margT8"
              >
                on {offer.name}'s {config?.secureWebsiteDisclaimer}
              </Label>
            </div>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};

export { StandardHomeEquityOffer };
